module.exports = __webpack_public_path__ + "img/second-day-2.77e97b76.png";